export class OperationKey {
  constructor(
    private readonly id: number,
    private readonly shortDescription: string,
    private readonly role: string,
    private readonly cipherData: string | null,
    private readonly wrappedKeyId: number | null,
    private readonly wrappedByKeyId: number | null
  ) {}

  getId() {
    return this.id;
  }

  getShortDescription() {
    return this.shortDescription;
  }

  getRole() {
    return this.role;
  }

  getCipherData() {
    return this.cipherData;
  }

  getWrappedKeyId() {
    return this.wrappedKeyId;
  }

  getWrappedByKeyId() {
    return this.wrappedByKeyId;
  }
}
